var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.css()] = true, _obj[_vm.css('', 'loading')] = _vm.loading, _obj ),attrs:{"data-test":"input-box"}},[_c('input',_vm._g(_vm._b({class:( _obj$1 = {}, _obj$1[_vm.css('field')] = true, _obj$1[_vm.css('field', 'error')] = _vm.error, _obj$1 ),attrs:{"data-test":"input"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }